import React from 'react';

const wrapComponentWith = WrappingComponent => Component => props => (
  <WrappingComponent>
    <Component {...props} />
  </WrappingComponent>
);

export default wrapComponentWith;
